import React from 'react';
import ReactDOM from 'react-dom';
import './assets/reset.css';
import './assets/index.css';
import App from './Components/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
